var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-button", {
    attrs: {
      type: "add",
      icon: "plus"
    },
    on: {
      click: _vm.handleAdd
    }
  }, [_vm._v(_vm._s(_vm.$t("添加") + _vm.$t("产品方案")))]), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.COLUMNSPLANLIST,
      "data-source": _vm.tableData,
      pagination: _vm.pagination,
      rowKey: "id"
    },
    on: {
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "status",
      fn: function (text, record) {
        return [_c("a-switch", {
          attrs: {
            checked: text == 1 ? true : false
          },
          on: {
            click: function ($event) {
              return _vm.checkedFun(record);
            }
          }
        })];
      }
    }, {
      key: "action",
      fn: function (text, record) {
        return [_c("a-button", {
          staticClass: "marginR15",
          attrs: {
            type: "edit",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.handleEdit(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("编辑")))]), _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            type: "copy",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.handleCopy(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("复制")))]), _c("a-button", {
          attrs: {
            type: "danger",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.handleDelete(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("删除")))])];
      }
    }])
  }, _vm._l(_vm.COLUMNSPLANLIST, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _vm.planShow ? _c("plan-modal", {
    ref: "planRef",
    on: {
      ok: _vm.getDataFun,
      cancel: function ($event) {
        _vm.planShow = false;
      }
    }
  }) : _vm._e(), _c("div", {
    staticClass: "btnBox"
  }, [_c("a-button", {
    staticClass: "marginR15",
    on: {
      click: function ($event) {
        return _vm.$emit("prev");
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("上一步")))]), _c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.saveFun
    }
  }, [_vm._v(_vm._s(_vm.$t("保存")))])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };